
(function storageDefinition() {
    'use strict';
    angular.module('Entities')
        .service('storageService', [
            'authExtend', function storageService(auth) {
                var stateBackFind = undefined;
                var advancedContainerFilter = {};
                var mydocumentFilter = {};
                var certificatesFilter = {};
                var paychecksFilter = {};
                var paychecksRrhhFilter = {};
                var processBatchFilter = {};
                var documentFilter = {};
                var documentRRHHFilter = {};
                var optionsPaychecksFilter = {};
                var optionsPaychecksRrhhFilter = {};
                var employeeFileMassiveImportsFilter = {};
                var optionsEmployeeFileMassiveImportsFilter = {};
                var employeeFilesFilter = {};
                var employeeFileCertificatesFilter = {};
                var auditFilter = {};
                var paychecksMultipleFilter = {};
                var statisticsRRhhFilter = {};
                var usersFilter = {};
                var that = this;
                var userQuery = {};
                var auditPagination = {};

                auth.onIdentityChanged(function () {
                    that.init();
                });

                this.setContainerFilter = function (filters) {
                    advancedContainerFilter = angular.copy(filters);
                };

                this.setMyDocumentFilter = function (filters) {
                    mydocumentFilter = angular.copy(filters);
                };

                this.setStateBackFind = function (state) {
                    stateBackFind = state;
                };

                this.setCertificatesFilter = function (filters) {
                    certificatesFilter = angular.copy(filters);
                };

                this.setPaychecksFilter = function (filters) {
                    paychecksFilter = angular.copy(filters);
                };

                this.setPaychecksRrhhFilter = function (filters) {
                    paychecksRrhhFilter = angular.copy(filters);
                };

                this.setProcessBatchFilter = function (filters) {
                    processBatchFilter = angular.copy(filters);
                };

                this.setDocumentFilter = function (filters) {
                    documentFilter = angular.copy(filters);
                };

                this.setDocumentRRHHFilter = function (filters) {
                    documentRRHHFilter = angular.copy(filters);
                };

                this.setPaychecksMultipleFilter = function (filters) {
                    paychecksMultipleFilter = angular.copy(filters);
                };

                this.setEmployeeFileMassiveImportsFilter = function (filters) {
                    employeeFileMassiveImportsFilter = angular.copy(filters);
                };

                this.setEmployeeFilesFilter = function (filters) {
                    employeeFilesFilter = angular.copy(filters);
                };


                this.setAuditPagination = function (filters) {
                    auditPagination = angular.copy(filters);
                };

                this.setStatisticsRRhhFilter = function (filters) {
                    statisticsRRhhFilter = angular.copy(filters);
                };

                this.setAuditFilter = function (filters) {
                    auditFilter = angular.copy(filters);
                }

                this.getMyDocumentFilter = function () {
                    return angular.copy(mydocumentFilter);
                };

                this.getContainerFilter = function () {
                    return angular.copy(advancedContainerFilter);
                };

                this.getCertificatesFilter = function () {
                    return angular.copy(certificatesFilter);
                };

                this.getPaychecksFilter = function () {
                    return angular.copy(paychecksFilter);
                };

                this.getPaychecksRrhhFilter = function () {
                    return angular.copy(paychecksRrhhFilter);
                };

                this.getProcessBatchFilter = function () {
                    return angular.copy(processBatchFilter);
                };

                this.getDocumentFilter = function () {
                    return angular.copy(documentFilter);
                };

                this.getDocumentRRHHFilter = function () {
                    return angular.copy(documentRRHHFilter);
                };

                this.getPaychecksMultipleFilter = function () {
                    return angular.copy(paychecksMultipleFilter);
                };

                this.getPaychecksOptionsFilter = function () {
                    return optionsPaychecksFilter;
                };

                this.getPaychecksRrhhOptionsFilter = function () {
                    return optionsPaychecksRrhhFilter;
                };

                this.getEmployeeFileMassiveImportsFilter = function () {
                    return angular.copy(employeeFileMassiveImportsFilter);
                };

                this.getEmployeeFileMassiveImportsOptionsFilter = function () {
                    return optionsEmployeeFileMassiveImportsFilter;
                };

                this.getEmployeeFilesFilter = function () {
                    return angular.copy(employeeFilesFilter);
                };

                this.getEmployeeFilesOptionsFilter = function () {
                    return optionsPaychecksFilter;
                };

                this.getAuditFilter = function () {
                    return angular.copy(auditFilter);
                };

                this.getAuditPagination = function () {
                    return angular.copy(auditPagination);
                };

                this.getAuditOptionsFilter = function () {
                    return angular.copy(auditFilter);
                };

                this.getStateBackFind = function () {
                    return stateBackFind;
                };

                this.setUserQuery = function (uq) {
                    userQuery = angular.copy(uq);
                };

                this.getUserQuery = function () {
                    return angular.copy(userQuery);
                };

                this.getStatisticsRRhhFilter = function () {
                    return angular.copy(statisticsRRhhFilter);
                };

                this.getOrganizationalUnitFilter = function () {
                    return employeeFilesFilter.organizationalUnit || certificatesFilter.organizationalUnit || paychecksRrhhFilter.organizationalUnit || processBatchFilter.organizationalUnit || employeeFileCertificatesFilter.organizationalUnit;
                };

                this.getUsersFilter = function () {
                    return angular.copy(usersFilter);
                };

                this.setUsersFilter = function (filters) {
                    usersFilter = angular.copy(filters);
                };

                this.getEmployeeFileCertificatesFilter = function () {
                    return angular.copy(employeeFileCertificatesFilter);
                };

                this.setEmployeeFileCertificatesFilter = function (filters) {
                    employeeFileCertificatesFilter = angular.copy(filters);
                };


                this.clearMyDocumentFilter = function () {
                    mydocumentFilter = {
                        showNoData: false,
                        code: ''
                    };
                };

                this.clearContainerFilter = function () {
                    advancedContainerFilter = {
                        showNoData: false,
                        ContainerTypes: [],
                        Name: '',
                        selectedContainerTypes: []
                    };
                };

                this.clearCertificatesFilter = function () {
                    certificatesFilter = {
                        name: null,
                        showNoData: false,
                        showResult: false,
                        processType: null,
                        selectedStates: [],
                        dateFrom: null,
                        dateTo: null,
                        orderBy: null,
                        organizationalUnit: undefined,
                        organizationalUnitId: auth.getOrganizationId(),
                        currentPage: 1
                    };
                };

                this.clearEmployeeDocumentsFilter = function () {
                    employeeDocumentsFilter = {
                        name: null,
                        showNoData: false,
                        showResult: false,
                        selectedProcessType: null,
                        selectedStates: undefined,
                        processTypes: [],
                        dateFrom: null,
                        dateTo: null,
                        documentsItems: [],
                        orderBy: null,
                        organizationalUnitId: auth.getOrganizationId(),
                        currentPage: 1
                    };
                };

                this.clearPaychecksFilter = function () {
                    paychecksFilter = {
                        name: null,
                        showNoData: false,
                        showResult: false,
                        processType: null,
                        selectedStates: [],
                        dateFrom: null,
                        dateTo: null,
                        orderBy: null,
                        organizationalUnitId: auth.getOrganizationId(),
                        currentPage: 1
                    };
                };

                this.clearPaychecksRrhhFilter = function () {
                    paychecksRrhhFilter = {
                        name: null,
                        showNoData: false,
                        showResult: false,
                        processType: null,
                        selectedStates: [],
                        dateFrom: null,
                        dateTo: null,
                        viewedDateFrom: null,
                        viewedDateTo: null,
                        orderBy: null,
                        organizationalUnit: undefined,
                        organizationalUnitId: auth.getOrganizationId(),
                        currentPage: 1
                    };
                };

                this.clearProcessBatchFilter = function () {
                    processBatchFilter = {
                        name: null,
                        showNoData: false,
                        showResult: false,
                        processType: null,
                        selectedStates: [],
                        createDate: null,
                        createdBy: { metadataLabel: '#ProcessCreatedBy', metadataValue: null },
                        orderBy: null,
                        organizationalUnit: undefined,
                        organizationalUnitId: auth.getOrganizationId(),
                        currentPage: 1
                    };
                };

                this.clearDocumentFilter = function () {
                    documentFilter = {
                        name: null,
                        showNoData: false,
                        showResult: false,
                        processType: null,
                        selectedStates: [],
                        readOnlyStates: [],
                        organizationalUnitId: undefined,
                        currentPage: 1
                    };
                };

                this.clearDocumentRRHHFilter = function () {
                    documentRRHHFilter = {
                        name: null,
                        showNoData: false,
                        showResult: false,
                        processType: null,
                        selectedStates: [],
                        dateFrom: null,
                        dateTo: null,
                        orderBy: null,
                        organizationalUnitId: auth.getOrganizationId(),
                        organizationalUnitName: auth.getOrganizationName(),
                        currentPage: 1
                    };
                };

                this.clearPaychecksMultipleFilter = function () {
                    paychecksMultipleFilter = {
                        name: null,
                        showNoData: false,
                        showResult: false,
                        selectedPaycheckType: null,
                        selectedState: undefined,
                        paycheckTypes: [],
                        dateFrom: null,
                        dateTo: null,
                        orderBy: null,
                        organizationalUnitId: auth.getOrganizationId(),
                        currentPage: 1
                    };
                };

                this.clearEmployeeFileMassiveImportsFilter = function () {
                    employeeFileMassiveImportsFilter = {
                        name: null,
                        showNoData: false,
                        showResult: false,
                        processType: null,
                        selectedStates: [],
                        dateFrom: null,
                        dateTo: null,
                        orderBy: null,
                        organizationalUnitId: auth.getOrganizationId(),
                        currentPage: 1
                    };
                };

                this.clearEmployeeFilesFilter = function () {
                    employeeFilesFilter = {
                        name: null,
                        showNoData: false,
                        showResult: false,
                        selectedEmployeeFileType: null,
                        selectedStates: undefined,
                        employeeFileTypes: [],
                        dateFrom: null,
                        dateTo: null,
                        employeeFilesItems: [],
                        orderBy: null,
                        organizationalUnit: undefined,
                        organizationalUnitId: auth.getOrganizationId(),
                        currentPage: 1
                    };
                };

                this.clearStatisticsRRhhFilter = function () {
                    statisticsRRhhFilter = {
                        showNoData: false,
                        showResult: false,
                        showChart: false,
                        processType: null,
                        selectedStates: [],
                        employeeFileTypes: [],
                        organizationalUnit: {
                            name: 'ALL'
                        },
                        currentPage: 1
                    };
                };

                this.clearUsersFilter = function () {
                    usersFilter = {
                        FirstName: null,
                        NickName: null,
                        LastName: null,
                        organizationalUnitId: auth.getOrganizationId(),
                        organizationalUnitName: auth.getOrganizationName(),
                        userEnabledUI: null,
                        employeeFile: null
                    };
                };

                this.clearEmployeeFileCertificatesFilter = function () {
                    employeeFileCertificatesFilter = {
                        employeeFile: undefined,
                        employeeFileNumber: undefined,
                        organizationalUnit: {
                            id: auth.getOrganizationId()
                        },
                        organizationalUnitId: auth.getOrganizationId(),
                        organizationalUnitName: auth.getOrganizationName(),
                        certificateType: 0,
                        expirationDateFrom: null,
                        expirationDateTo: null,
                        withCertificate: true,
                        certificateProviders: [],
                        showResult: false,
                        firstSearch: true
                    };
                };

                this.clearAuditFilter = function () {
                    auditFilter = {
                        user: {
                            description: {
                                userId: null
                            }
                        },
                        userId: null,
                        showNoData: false,
                        showResult: false,
                        actionType: null,
                        dateFrom: null,
                        dateTo: null,
                        auditItems: [],
                        orderBy: null,
                        organizationalUnit: {
                            id: undefined,
                            name: ''
                        },
                        currentPage: 1,
                        firstTime: true,
                        employeeFile: undefined,
                        employeeFileNumber: undefined
                    };
                }

                this.clearAuditPagination = function () {
                    auditPagination = {
                        currentPage: 1,
                        totalItems: 0,
                        from: 0,
                        itemPerPage: 15
                    }                    
                }

                this.init = function () {
                    this.clearMyDocumentFilter();
                    this.clearContainerFilter();
                    this.clearCertificatesFilter();
                    this.clearPaychecksFilter();
                    this.clearPaychecksRrhhFilter();
                    this.clearDocumentFilter();
                    this.clearDocumentRRHHFilter();
                    this.clearEmployeeFilesFilter();
                    this.clearEmployeeFileMassiveImportsFilter();
                    this.clearPaychecksMultipleFilter();
                    this.clearStatisticsRRhhFilter();
                    this.clearUsersFilter();
                    this.clearProcessBatchFilter();
                    this.clearEmployeeFileCertificatesFilter();
                    this.clearAuditFilter();
                    this.clearAuditPagination();
                    stateBackFind = undefined;
                };

                this.init();
            }
        ]);

})();